module.exports = __webpack_public_path__ + "img/changeGrooves-2.9fd9bcc.webp";